<template>
    <button v-bind:class="{'btn-disabled': disabled, 'btn-big': big, 'layout-gom': layoutGom}" @click="handleClick()">
        <img v-if="!text" :src="icon" v-bind:class="{'btn-big-img': big, 'black': black}">
        <span v-else v-text="text"></span>
    </button>
</template>

<script>
export default {
  name: 'CircleButton',
  props: [
    'icon',
    'disabled',
    'big',
    'black',
    'layoutGom',
    'text'
  ],
  methods: {
    handleClick: function () {
      this.$emit('circleBtnClick')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>

    @import (reference) url("../../assets/common.less");

    button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        border: none;
        outline: none;
        color: @white;
        border-radius: 45px;
        background: none;
    }

    .btn-disabled {
        color: @black;
        background: @disabled-color;
        pointer-events: none
    }

    .btn-big {
        width: 35px;
        height: 35px;
    }
    .btn-big-img {
        width: 25px;
    }

    .black {
        filter: brightness(0);
    }

    img {
      width: 20px;
      filter: brightness(0);
    }
    .layout-gom {
        width: 8rem;
        span {
            font-size: 1.4rem;
        }
    }

</style>
